/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Meta_DescriptionInputs */

const es_cap_meta_description = /** @type {(inputs: Cap_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Eres patrón? Conectamos armadores con capitanes de confianza. Más clientes, trabajo por libre y tú eliges las salidas. Regístrate en Zarpar.`)
};

const gl_cap_meta_description = /** @type {(inputs: Cap_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es patrón? Conectamos armadores con patróns de confianza. Máis clientes, traballo por libre e ti elixes as saídas. Rexístrate en Zarpar.`)
};

const en_cap_meta_description = /** @type {(inputs: Cap_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you a skipper? We connect owners with trusted captains. More clients, freelance work and you choose your trips. Register on Zarpar.`)
};

/**
* | output |
* | --- |
* | "Are you a skipper? We connect owners with trusted captains. More clients, freelance work and you choose your trips. Register on Zarpar." |
*
* @param {Cap_Meta_DescriptionInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_meta_description = /** @type {((inputs?: Cap_Meta_DescriptionInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Meta_DescriptionInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_meta_description(inputs)
	if (locale === "en") return en_cap_meta_description(inputs)
	return es_cap_meta_description(inputs)
});